module.exports = __webpack_public_path__ + "0e94a70cb370d17f8cf36b51a4cde63a.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/polo.jpg
// module id = 848
// module chunks = 0